import React from 'react';
import clsx from 'clsx';

interface SpinnerProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ className = "w-16 h-16", ...props }) => {
    return (
        <img
            src="/boar_track_v2_a_png.png"
            alt="Loading..."
            className={clsx(className)}
            {...props}
        />
    );
};
